import Controller from '@ember/controller';
import { action } from '@ember/object';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { ReportLayout } from 'webapp/enums/enums';
import { getReturnUrlFromTransition } from 'webapp/utils/common';

import type Report from 'webapp/models-custom/report';

export default class ReportsEditorReportController extends Controller {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	@tracked declare report: Report;
	@tracked isPagelessView = true;

	@tracked selectedSlideId: string | null = null;

	enteringTransition: PublicTransition | null = null;

	@action
	changeSlide(slideId: string | null): void {
		this.selectedSlideId = slideId;
	}

	@action
	changeViewMode(isPagelessView: boolean): void {
		if (!isPagelessView) {
			void this.cleanupEmptyCover();
		}
		this.isPagelessView = isPagelessView;
		this.report.layout = isPagelessView ? ReportLayout.PAGELESS : ReportLayout.SLIDES;
		void this.report.saveAndCatch();
	}

	@action
	closeEditor() {
		const report = this.report;
		const isTemplate = report.isTemplate;
		let routeName = isTemplate ? 'reports.account-templates' : 'reports';

		const previousRoute = this.enteringTransition;
		if (previousRoute && previousRoute.from?.name === 'teams.view') {
			const exitUrl = getReturnUrlFromTransition(
				previousRoute,
				this.navigationService.router,
			);
			routeName = exitUrl;
		}
		this.navigationService.transitionToRoute(routeName).then(() => {
			this.mmBoardsService.checkMaxBoardIdsToRemember();
		});
	}

	private async cleanupEmptyCover(): Promise<void> {
		if (this.report.isEmpty) {
			const firstSlide = this.report.firstSlide;
			if (firstSlide?.isTypeCover) {
				await firstSlide.deleteAndCatch();
			}
		}
	}
}
